export const first_arr = (arr) => {
  if (arr.length > 0) return arr[0];
  return null;
};

export const last_arr = (arr) => {
  if (arr?.length > 0) return arr[arr?.length - 1];
  return null;
};

export const removeDuplicates = (arr) => [...new Set(arr)];
